export function b64EncodeUnicode(str: string) {
	return window.btoa(unescape(encodeURIComponent(str)));
}
